import { KeyboardDoubleArrowLeft, Download } from "@mui/icons-material";
import { Button, CircularProgress, Grid, Stack, Typography } from "@mui/material";
import React, { useState } from "react"
import { useNavigate, useParams } from "react-router";
import { RefundWorklistResults } from "../features/worklist/RefundWorklistResults";
import { CenterNameView } from "../../../components/orgComponents";
import { exportUspiRefunds, downloadBlob } from "../../../services/refundService/uspiExport";

function RefundWorklist(){
    const {status} = useParams();
    const navigate = useNavigate();
    const {center} = useParams();
    const [exporting, setExporting] = useState(false);

    const isUspiWorklist = status === 'USPI';

    const handleExportCsv = async () => {
        if (!center) return;
        
        setExporting(true);
        try {
            const { blob, filename } = await exportUspiRefunds(center);
            downloadBlob(blob, filename);
        } catch (error) {
            console.error('Export failed:', error);
        } finally {
            setExporting(false);
        }
    };
   
    return <React.Fragment>
        <Grid container justifyContent='space-between' marginBottom='10px'>
            <Grid item sm={4.75}>
                <CenterNameView centerId={center!}/>
            </Grid>
            <Grid item sm={4}>
                <Typography variant='h5' className="psn-green">{status + ' Worklist'}</Typography>
            </Grid>
            <Grid item sm={3}>
                <Stack direction='row' gap={1} justifyContent='flex-end'>
                    {isUspiWorklist && (
                        <Button 
                            variant='outlined' 
                            startIcon={exporting ? <CircularProgress size={16} /> : <Download/>} 
                            color='success' 
                            onClick={handleExportCsv}
                            disabled={exporting}
                        >
                            {exporting ? 'Exporting...' : 'USPI Export'}
                        </Button>
                    )}
                    <Button variant='outlined' startIcon={<KeyboardDoubleArrowLeft/>} color='success' onClick={()=>navigate(-1)}>Back</Button>
                </Stack>
            </Grid>
        </Grid>
        <RefundWorklistResults/>
    </React.Fragment>
}

export{RefundWorklist}